<div class="offline-traffic">
  <ng-container *ngIf="isLoading$ | async">
    <coa-foot-traffic-skeleton class="offline-traffic__chart-skeleton"></coa-foot-traffic-skeleton>
  </ng-container>

  <ng-container *ngIf="offlineTrafficError$ | async">
    <div class="offline-traffic__error">{{ 'Error while loading foot traffic' | translate }}</div>
  </ng-container>

  <ng-container *ngIf="(isLoading$ | async) === false && (offlineTrafficError$ | async) === false">
    <coa-dashboard-offline-traffic-empty
      *ngIf="noData"
      class="offline-traffic__no-data">
    </coa-dashboard-offline-traffic-empty>

    <ng-container *ngIf="!noData">
      <ng-container *ngIf="offlineTraffics?.length > 1">
        <div class="offline-traffic__header">
          <div class="header">
            <div>
              <span class="offline-traffic__header-text" data-cy="offline-traffic.title">
                {{'Foot traffic in OWN and COMPETITORS Stores' | translate}}
              </span>
              <coa-icon-tooltip
                [tooltip]="tooltip | translate"
                class="offline-traffic__header-tooltip">
              </coa-icon-tooltip>
            </div>
          </div>
        </div>

        <coa-spy-line-chart
          [dataset]="offlineTrafficSeries | chartDataMultiSeries : offlineTrafficLabels"
          [yAxisTicksConfig]="[offlineTraffic.offlineTraffic] | scaleTicks"
          class="offline-traffic__chart">
        </coa-spy-line-chart>
      </ng-container>

      <ng-container *ngIf="offlineTraffics?.length === 1">
        <div class="offline-traffic__header">
          <div class="header">
            <div>
              <span class="offline-traffic__header-text" data-cy="offline-traffic.title">
                {{'Foot traffic' | translate}}
              </span>
              <coa-icon-tooltip
                [tooltip]="tooltip | translate"
                class="offline-traffic__header-tooltip">
              </coa-icon-tooltip>
            </div>

            <div
              *ngIf="paymentsEnabled && uniqueEnabled"
              class="switch">
              <div
                (click)="showUniqueVisits()"
                [ngClass]="{'switch--active': chartExtendedData === chartExtendedDataType.UNIQUE_VISITS}"
                class="switch__item">
                {{'UNIQUE VISITS' | translate}}
              </div>

              <div
                (click)="showPayments()"
                [ngClass]="{'switch--active': chartExtendedData === chartExtendedDataType.PAYMENTS}"
                class="switch__item">
                {{'PAYMENTS' | translate}}
              </div>
            </div>
          </div>
        </div>

        <coa-multiple-series-chart
          [clientId]="clientId"
          [label]="offlineTraffic.seriesName"
          [primaryDataset]="offlineTraffic | dataSeries : chartExtendedDataType.VISITS"
          [secondaryDataset]="offlineTraffic | dataSeries : chartExtendedData"
          class="chart"
          data-cy="store-details.foot-traffic-chart">
        </coa-multiple-series-chart>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
